import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as propTypes from 'prop-types';


interface SelectButtonProps {
    getToggleButtonProps: any;
    isOpen: boolean;
}

const SelectButton = ({ getToggleButtonProps, isOpen }: SelectButtonProps) => {
    return (
        <button
            {...getToggleButtonProps()}
            className="sid-select-button"
        >
            <svg
                viewBox="0 0 20 20"
                preserveAspectRatio="none"
                width={16}
                fill="transparent"
                stroke="#979797"
                strokeWidth="1.1px"
                transform={isOpen ? 'rotate(180)' : undefined}
            >
                <path d="M1,6 L10,15 L19,6" />
            </svg>
        </button>
    );
};

SelectButton.propTypes = {
    isOpen: propTypes.bool.isRequired,
};

export const SelectButtonComponent = SelectButton;
